import { IBusinessEntity } from '@commenda/types';
import { ForeignQualificationRegistration } from '../../BusinessInformation/BusinessInformationTabs/Registration/ForeignQualificationRegistration';
import { TaxInformation } from '../../BusinessInformation/BusinessInformationTabs/Tax';
import { SummaryInfoWrapper } from './SummaryInfoWrapper';

type TaxAndRegistrationCardProps = {
  businessEntity: IBusinessEntity;
  onGoToForm: () => void;
};

export const TaxAndRegistrationCard = ({
  businessEntity,
  onGoToForm,
}: TaxAndRegistrationCardProps) => {
  return (
    <SummaryInfoWrapper title="Tax and Registration" onGoToForm={onGoToForm}>
      <div className="flex flex-col gap-3xl mt-2">
        <TaxInformation
          businessEntity={businessEntity}
          hideDescription
          hideCopyIconForFields={{
            accountingBasis: true,
            taxClassification: true,
          }}
          hideEditIconForFields={{
            accountingBasis: true,
            taxClassification: true,
          }}
        />

        <ForeignQualificationRegistration
          businessEntity={businessEntity}
          hideAddButton
          hideActions
        />
      </div>
    </SummaryInfoWrapper>
  );
};
